export default {
  getReviewHistory: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/reviewHistory`),
  setReviewHistory: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/reviewHistory`,
      data,
    ),
}
